import { render, staticRenderFns } from "./widget-folder.vue?vue&type=template&id=5d3267e0&"
import script from "./widget-folder.vue?vue&type=script&lang=js&"
export * from "./widget-folder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports